$(document).ready(function(e){

    function subscribe_set(subscription_type = $("input[name='subscription-type']:checked")) {
        var product_info = subscription_type.closest("product-info");
        if (subscription_type.val() == 'one_time') {
            product_info.find('[name="properties[_frequency]"]:checked').removeAttr("checked").prop("checked", false).trigger("change");
            product_info.find('[name="properties[_subscription]"]').removeAttr("checked").prop("checked", false).trigger("change");
        } else if (subscription_type.val() == 'subscribe') {
            product_info.find('[name="properties[_frequency]"]:first').attr("checked","checked").prop("checked", true).trigger("change");
            product_info.find('[name="properties[_subscription]"]').attr("checked", "checked").prop("checked", true).trigger("change");
        }
    }

    subscribe_set();

    $('body').on("change","input[name='subscription-type']", function(e){
        e.preventDefault();
        var _this = $(this);
        subscribe_set(_this);
    });

});